import styled, { css, keyframes } from 'styled-components';
import { colors, ApMenu } from '@alixpartners/ui-components';
import { transparentize } from 'polished';
import PropTypes from 'prop-types';
import { brandColors } from 'styles/colors';
const spinner = keyframes`
	from {
		opacity: 1;
	}

	to {
		transform: rotate(360deg);
		opacity: 1;
	}
`;

const scaleIn = keyframes`
	from {
		transform: scale(0.8) rotate(-120deg);
		opacity: 0;
	}

	to {
		opacity: 1;
	}
`;
export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	max-width: 272px !important;
	min-width: 200px !important;
	max-height: calc(100% - 102px) !important;

	${({ isVirtualList }) =>
		isVirtualList &&
		css`
			height: 100%;
		`};
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 100%;
	height: 100%;
	overflow: hidden;
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid ${colors.grey2};
`;

export const SearchWrapper = styled.div`
	display: flex;
	padding: 8px;

	> div {
		width: 100%;
	}
`;

export const VirtualListWrapper = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	overflow: hidden;
`;

export const CheckboxListWrapper = styled.div`
	overflow: auto;
`;

export const NoData = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	font-size: 16px;
	line-height: 20px;
	color: ${colors.grey6};
	padding: 8px 9px;
`;

export const CounterWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: -8px;
	border-radius: 16px;
	background-color: ${colors.green2};
	height: 16px;
	min-width: 16px;
	color: white;
	font-size: 11px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	z-index: 2;
`;

export const GroupLabel = styled.div`
	display: flex;
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 16px;
	padding: 10px 8px 10px 34px;
`;
export const SmallSpinner = styled.span`
	display: block;
	width: ${props => props.size}px;
	height: ${props => props.size}px;
	border-radius: 50%;
	border: ${props =>
		`${props.thickness || props.size / 12}px solid ${transparentize(
			0.666,
			'white'
		)}`};
	border-top-color: ${props => props.color};
	animation: ${scaleIn} 200ms linear 1 ${props => props.delay}ms,
		${spinner} 600ms linear infinite ${props => props.delay + 200}ms;
	// After deployment, spinner is receiving extra style 'padding: 40px 20px 20px', adding style to nulify that style
	&& {
		padding: 0;
	}
`;

SmallSpinner.propTypes = {
	color: PropTypes.string,
	delay: PropTypes.number,
	size: PropTypes.number,
	thickness: PropTypes.number,
};

SmallSpinner.defaultProps = {
	color: brandColors.green,
	delay: 0,
	size: 46,
	thickness: 8,
};
